import { __assign } from "tslib";
import { Box } from '../Box';
import { MenuItem } from '../MenuItem';
import { OffScreenAnnouncement } from '../OffScreenAnnouncement';
import { Combobox } from './components/Combobox.Combobox';
import { SingleValue } from './components/Combobox.SingleValue';
import { MultiValue } from './components/Combobox.MultiValue';
import { InputWrap } from './components/Combobox.InputWrap';
import { Listbox } from './components/Combobox.Listbox';
import { MenuItem as ComboboxMenuItem } from './components/Combobox.MenuItem';
import { MenuListSubheader } from './components/Combobox.MenuListSubheader';
import { Search } from './components/Combobox.Search';
export var components = {
    Combobox: Combobox,
    InputWrap: InputWrap,
    Listbox: Listbox,
    MenuListSubheader: MenuListSubheader,
    LoadingResultsMenuItem: MenuItem,
    MenuItem: ComboboxMenuItem,
    MultiValue: MultiValue,
    NoResultsMenuItem: MenuItem,
    OffScreenAnnouncement: OffScreenAnnouncement,
    Search: Search,
    SingleValue: SingleValue,
    ValueWrap: Box,
};
export var defaultComponents = function (overrideComponents) { return (__assign(__assign({}, components), overrideComponents)); };
//# sourceMappingURL=Combobox.components.js.map